import bfTabsBody from './bf-tabs-body.vue';
bfTabsBody.install = Vue => Vue.component(bfTabsBody.name,bfTabsBody);
export default bfTabsBody;



// WEBPACK FOOTER //
// ./src/packages/tabs/bf-tabs-body/index.js